<div id="message" style="background-color:#e5e5e5"></div>
<button api_login_id=fD74V1lSx2
        version_number=1.0
        method=sale		total_amount="{1375.23,1573.66,56.99,0|Total outstanding,Last statement balance,Minimum balance,Specify different amount};500.00"
        utc_time=638264891630612864		signature=5073ba22886c5616a0123c650fa7ce59
        order_number=A1234
        (click)="oncallback($event)"
>Pay now</button>
